import { formatTestimonial } from "utils/prismic"
import ContentPageContainer from "components/molecules/common/ContentPageContainer"
import { RichText } from "prismic-reactjs"

export default function TestimonialTemplate({ pageContext: { content } }) {
  const {
    title,
    logo,
    logo_alt,
    text,
    fact_large,
    fact_small,
    person_name,
    person_description,
  } = formatTestimonial(content)

  return (
    <ContentPageContainer title={title}>
      <div className="flex flex-col items-start space-y-8 py-10 sm:flex-row sm:space-x-8 sm:space-y-0">
        {logo ? (
          <img
            src={logo}
            alt={logo_alt}
            className="-mt-2 w-48 shrink-0 sm:mx-auto"
          />
        ) : null}
        <div className="flex flex-col items-start sm:space-y-6">
          <p className="mb-0 grow whitespace-pre-line text-left font-body text-base text-zinc-800">
            <RichText render={text} />
          </p>
          {person_name ? (
            <div className="mt-4 text-base text-stone-800">
              <p className="m-0 font-extrabold">{person_name}</p>
              <p className="m-0">{person_description}</p>
            </div>
          ) : null}
        </div>
      </div>
      <div className="space-y-4 py-10 ">
        <div className="font-display text-5xl text-zinc-800 underline">
          {fact_large}
        </div>
        <div className="font-display text-2xl text-zinc-800">{fact_small}</div>
      </div>
    </ContentPageContainer>
  )
}
